"use client";

import useMediaQuery from "@core/helpers/client/hooks/useMediaQuery";

// Tailwind's `lg:` and up ("(min-width: 64rem)"), so `lg:hidden` / `hidden lg:block` and this hook agree.
// From jument and ciseco `useIsDesktop`: null on the server and during hydration (no device guess; the caller renders
// both trees until it knows).
// options:
// - breakpoint: a number (px) or a CSS length. Default "64rem".
// - query: a full media query instead of the breakpoint.
// - server_value: value on the server and during hydration. Default null.
export default function useIsDesktop({ breakpoint = "64rem", query, server_value = null } = {}) {
	const min = typeof breakpoint === "number" ? `${breakpoint}px` : breakpoint;
	return useMediaQuery(query || `(min-width: ${min})`, { server_value });
}
